import { nip19 } from 'nostr-tools';
import { useParams } from 'react-router-dom';
import NotFound from './NotFound';
import { EpisodePage } from './EpisodePage';

export function NIP19Page() {
  const { nip19: identifier } = useParams<{ nip19: string }>();

  if (!identifier) {
    return <NotFound />;
  }

  let decoded;
  try {
    decoded = nip19.decode(identifier);
  } catch {
    return <NotFound />;
  }

  const { type } = decoded;

  switch (type) {
    case 'note':
      return <EpisodePage eventId={decoded.data} />;

    case 'nevent':
      return <EpisodePage eventId={decoded.data.id} />;

    case 'npub':
    case 'nprofile':
    case 'naddr':
      // Redirect to njump for now
      window.location.href = `https://njump.me/${identifier}`;
      return null;

    default:
      return <NotFound />;
  }
}
